import { render, staticRenderFns } from "./StockList.vue?vue&type=template&id=a203e1e4&scoped=true&lang=pug&"
import script from "./StockList.vue?vue&type=script&lang=ts&"
export * from "./StockList.vue?vue&type=script&lang=ts&"
import style0 from "./StockList.vue?vue&type=style&index=0&id=a203e1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a203e1e4",
  null
  
)

export default component.exports